import React, { useState } from 'react'
import { Container, Row, Col, Form } from "react-bootstrap";
import '../componentCss/webform.css';
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import Dashboardheader from './dashboardheader';
import Sidebar from './sidebar';
import '../componentCss/sidebar.css';
import toast from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import { BsArrowLeftCircleFill } from "react-icons/bs";
import config from '../../config/config';
import { Link } from "react-router-dom";
import { addDepartmentSchema } from "../../validations/staffSchema";
import { addCategoryAction } from '../../Action/admin.action';

const AddFormCategory = () => {
    const navigate = useNavigate();
    const [formData, setForm] = useState({ name: '' })
    const [isLaoding, setisLaoding] = useState(0)

    let handleSubmit = async (values) => {
        setisLaoding(1)
        let res = await addCategoryAction(values);
        if (res.success) {
            toast.success(res.msg);
            setTimeout(() => {
                navigate(`${config.baseUrl}form-category-list`);
            }, 2000);
        } else {
            setisLaoding(0)
            toast.error(res.msg);
        }
    }

    return (
        <>
            <Dashboardheader />
            <div className="wrapper">
                <Sidebar />
                <div id="content">
                    <Container fluid className="p-4">
                        <Row>
                            <Col lg={12} md={12} sm={12} className="">
                                <div className="innerhead mb-4">
                                    <h5 className='headtitle'>Add New Category</h5>
                                </div>
                                <Link to={`${config.baseUrl}form-category-list`} >
                                    <span style={{ float: 'right' }}>Back <BsArrowLeftCircleFill /></span>
                                </Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} md={12} sm={12} className="">
                                <div className='formDiv'>
                                    <Formik
                                        initialValues={formData}
                                        validationSchema={addDepartmentSchema}
                                        onSubmit={(values) => {
                                            handleSubmit(values);
                                        }}
                                    >
                                        {({
                                            errors,
                                            handleSubmit,
                                            handleBlur,
                                            handleChange,
                                            touched,
                                            values,
                                        }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <Row className="mb-4">
                                                    <Form.Group as={Col}>
                                                        <Form.Label>Name</Form.Label>
                                                        <input className='form-control' type="text" name='name' onChange={handleChange} placeholder="Please enter category name" onBlur={handleBlur} value={values.name} />

                                                        {errors.name && touched.name && (
                                                            <div className="text-danger">
                                                                {errors.name}
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-4">
                                                    <Form.Group as={Col}>
                                                        {isLaoding ?
                                                            <>
                                                                <button disabled className='px-3 py-2 btn-sm btn-secondary-btn3 fs-6'>Loading <img height="20" width="20px" src="assets/images/loading.gif" /></button>
                                                            </>
                                                            :
                                                            <button type='submit' className='px-3 py-2 btn-sm btn-secondary-btn3 fs-6'>Submit</button>
                                                        }
                                                    </Form.Group>
                                                </Row>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </div >
        </>
    )
}

export default AddFormCategory;
